import { httpClient } from 'shared/services/http/httpClient';
import { applicantRoleBuilder, ApplicantRoleDto, ApplicantRoleModel } from '../models/ApplicantRole';

const useApplicantRoleService = () => {
  const getRoles = async (): Promise<ApplicantRoleModel[]> => {
    const res = await httpClient.get('referents-roles');
    return (res as ApplicantRoleDto[]).map(applicantRoleBuilder.fromBackend);
  };

  return { getRoles };
};

export default useApplicantRoleService;
